"use client";

import { FC } from "react";
import Content from "./components/Content";
import TradingView from "./components/TradingView/TradingView";
import ViewHolder from "./components/TradingView/ViewHolder";
import SwapForm from "./swap-form";

const Swap: FC = () => {
    return (
        <Content>
            <SwapForm />
            <ViewHolder>
                <TradingView />
            </ViewHolder>
        </Content>
    );
};

export default Swap;
